import { PureComponent } from 'react'
import { inject } from 'mobx-react'
import PropTypes from 'prop-types'
import ExtensionManager from '@App/extensions/ExtensionManager'

@inject('ExtensionStore')
export default class ExtensionContext extends PureComponent {
  static contextTypes = {
    ExtensionManager: PropTypes.object,
  }

  static childContextTypes = {
    ExtensionManager: PropTypes.object,
  }

  constructor(props, context) {
    super(props, context)

    const { name, data, ExtensionStore } = props
    const isRoot = !this.context.ExtensionManager
    const scope = {}

    this.manager = ExtensionManager(name, data, context.ExtensionManager, scope, ExtensionStore)

    if (isRoot && typeof window === 'object') {
      const { ExtensionStore } = window.__NEXT_DATA__.props.initialMobxState

      const descriptors = (ExtensionStore && ExtensionStore.extensions) || []
      descriptors.push = this.push
    }
  }

  componentDidUpdate({ data }) {
    if (!data) return
    this.manager.updateData(data)
  }

  push = (...configs) => {
    this.manager.push(...configs)
  }

  getChildContext() {
    return {
      ExtensionManager: this.manager,
    }
  }

  render() {
    const { children } = this.props

    if (!children) return null

    return children
  }
}
